import jwtInterceptor from "@/shared/jwtInterceptor";


const apiUrl= process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const state = () => ({
  messageCount:0,
  activeOrderCount:0,
  uniqueId:null,
  pageTitle:'',
  pageLoading:false,
  showHead : true,
});

const actions = {
  async setPageTitle({commit},title)
  {
    commit('setPageTitle',title)
  },
  async setPageLoading({commit},status)
  {
    commit('setPageLoading',status)
  },
  async setShowHead({commit},st)
  {
    commit('setShowHead',st)
  },

  async getStates()
  {
    const url = apiUrl + 'app/getState';
    var response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data.states
    }
  },
  async getGuildForSelect()
  {
    const url = apiUrl + 'getAllGuildsForSelect';
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getProductBrand(c,id)
  {
    const url = apiUrl + 'productBrand/get/'+id;
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getProductAttributeInfo(c,id)
  {
    const url = apiUrl + 'productAttribute/getInfo/'+id;
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async ProductAttributeAddNewItem(c,items)
  {
    const url = apiUrl + 'productAttribute/addValue';
    var response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
  },
  async ProductAttributeItemEditTitle(c,items)
  {
    const url = apiUrl + 'productAttribute/editItemTitle';
    var response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
  }


};

const mutations = {
  setPageTitle(state,title)
  {
    state.title = title
  },
  setPageLoading(state,status)
  {
    state.status = status
  },
  setShowHead(state,st)
  {
    state.st = st;
  }
}

const getters = {
  pageTitle(state)
  {
    return state.title
  },
  pageLoading(state)
  {
    return state.status;
  },
  showHead(state)
  {
    return state.st;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}